import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import DimensionType from "./actionTypes"

import DimensionAction from "./actions"

import DimensionAPI from "helpers/dimension_backend_helper"

function* fetchListOnPage({ payload }) {
  yield put(
    DimensionAction.getListPageSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    const currentPage = payload.page
    let { data } = yield call(DimensionAPI.getListPage, {
      ...payload,
      page: currentPage,
    })
    yield put(
      DimensionAction.getListPageSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      DimensionAction.getListPageSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchDetail({ payload, action }) {
  yield put(
    DimensionAction.getDetailSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(DimensionAPI.getDetail, payload.id)

    action(data)
    yield put(
      DimensionAction.getDetailSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      DimensionAction.getDetailSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchPostData({ payload, action }) {
  yield put(
    DimensionAction.postDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(DimensionAPI.postData, payload)

    yield put(
      DimensionAction.postDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    action(false, error.data.errors[0])
    yield put(
      DimensionAction.postDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchPutData({ payload, action }) {
  yield put(
    DimensionAction.putDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(DimensionAPI.putData, payload)

    yield put(
      DimensionAction.putDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    action(false, error.data.errors[0])
    yield put(
      DimensionAction.putDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchList({ payload }) {
  yield put(
    DimensionAction.getListSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(DimensionAPI.getList, payload)
    yield put(
      DimensionAction.getListSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      DimensionAction.getListSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchListFrameType({ payload }) {
  yield put(
    DimensionAction.getListFrameTypeSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(DimensionAPI.getFrameType)
    yield put(
      DimensionAction.getListFrameTypeSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      DimensionAction.getListFrameTypeSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchListDimensionCategory({ payload }) {
  yield put(
    DimensionAction.getListDimensionCategorySuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(DimensionAPI.getDimensionProductCategory)
    yield put(
      DimensionAction.getListDimensionCategorySuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      DimensionAction.getListDimensionCategorySuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* dimensionSaga() {
  yield takeEvery(DimensionType.GET_DIMENSION_PAGES, fetchListOnPage)
  yield takeEvery(DimensionType.GET_DETAIL_DIMENSION_BY_ID, fetchDetail)
  yield takeEvery(DimensionType.POST_DIMENSION, fetchPostData)
  yield takeEvery(DimensionType.PUT_DIMENSION, fetchPutData)
  yield takeEvery(DimensionType.GET_DIMENSION_LIST, fetchList)
  yield takeEvery(DimensionType.GET_DIMENSION_FRAME_TYPE, fetchListFrameType)
  yield takeEvery(
    DimensionType.GET_DIMENSION_LIST_CATEGORY,
    fetchListDimensionCategory
  )
}

export default dimensionSaga
